import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Theme = 'light' | 'dark'

interface ThemeState {
  theme: Theme
  setTheme: (theme: Theme) => void
  toggleDark: () => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'light',

      setTheme: (theme) => set({ theme }),

      toggleDark: () => {
        const current = get().theme
        set({ theme: current === 'dark' ? 'light' : 'dark' })
      },
    }),
    {
      name: 'dentistg-theme',
    }
  )
)
